<template>
    <div class="wrapper" @click="isDo()">
        <v-head ref="header"></v-head>
		<v-sidebar ref="sidebar" :sLanguage="sLanguage"></v-sidebar>
        <div class="content-box" :class="{'content-collapse':collapse}">
            <v-tags ref="tags"></v-tags>
            <div class="content" v-if="show">
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view :sLanguage="sLanguage"></router-view>
                    </keep-alive>
                </transition>
                <el-backtop target=".content"></el-backtop>
            </div>
        </div>
    </div>
</template>

<script>
import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
import vTags from './Tags.vue';
import bus from './bus';
export default {
    data() {
        return {
            tagsList: [],
            collapse: false,
            sLanguage: 0,
			show: true,
			lastDate: new Date(), // 最后一次点击的时间
            home: {
                home_0: "您已超时,请重新登录",
                home_1: "提示",
                home_2: "确定",
                home_3: "请求失败"
            },
        };
    },
    components: {
        vHead,
        vSidebar,
        vTags
    },
	watch: {
	    sLanguage(newVal,oldVal) { // 监听语言变更
			sessionStorage.removeItem('ms_SideBar');
			this.getSideBar();
			this.show = false;
			this.$nextTick(function () {
				this.show = true;
			});
	    }
	},
    created() {
        bus.$on('collapse-content', msg => {
            this.collapse = msg;
        });

        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', msg => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        });
    },
	methods: {
		// 获取sidebar
		getSideBar(){
			var postUrl = 'WCF/WEB/svcBAG.svc/GET_BAG_TreeListByUEMAIL';
			var web_suuid = sessionStorage.getItem('ms_username');

			this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sUAAID: sessionStorage.getItem("ms_web_suuid"), //web侧 登录ID  tihs.web_suuid
						sEmail: sessionStorage.getItem("ms_username"), //web侧 登录邮箱
						sLogin: sessionStorage.getItem("ms_username"), // 登录邮箱
						sLanguage: 0//语言
					})
				.then((response) => {
					if (response.status === 200) {
						//请求成功
						// 重新制作sidebar
						var sidebarArr = this.$refs.sidebar.createSidebar(response.data);
						// 重新保存
						sessionStorage.setItem('ms_SideBar', JSON.stringify(sidebarArr));
						sessionStorage.setItem('ms_BAG', JSON.stringify(response.data));
						this.$refs.sidebar.items = sidebarArr;
						this.$refs.tags.changeLanguage(response.data);
					}
				})
		},
		// 是否进行操作了
		isDo() {
			// 进行操作了重新计时
			this.lastDate = new Date();
		},
		// 消息已读header未读消息数减少
		headerMessageRead() {
			this.$refs.header.messageRead();
		},
		// 一小时未进行点击，timeout
		oneHourCleanSession() {
			// 一小时清理session
			let interval = setInterval(() => { // 每2秒比对一次
				let nowDate = new Date();
				if ( nowDate.getTime() - this.lastDate > 3600000){ // 到达一小时
					clearInterval(interval);
					sessionStorage.clear();
					this.$store.commit('setHasRouter', false);
					this.$alert(this.home.home_0, this.home.home_1, {
					          confirmButtonText: this.home.home_2,
					          callback: action => {
								this.$router.push('/login');
								location.reload();
					          }
							});
				}
			}, 2000)
		},
		// 头像变更方法
		headerImgChange() {
			this.$refs.header.changeImg();
		}
	},
	mounted() {
		this.oneHourCleanSession();
	}
};
</script>
<style>
	.el-dialog__footer {
		text-align: center;
	}
</style>
